import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameFormatter',
  standalone: false
})
export class NameFormatterPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return '';
    
        let parts = value.trim().split(', '); // Trim and split by ", "
        if (parts.length !== 2) return value; // Return original if format is incorrect
    
        let firstInitial = parts[1].trim().charAt(0) + '.'; // Get first letter from LASTNAME
        return `${firstInitial} ${parts[0]}`; // Format as "E. Allman"
      }

}
